import {InputNumber, Modal, Radio, Row, Col, Input} from 'antd';
import {useState} from "react";
import {InventoryAdjustmentType} from "../../api/Constants";

const {TextArea} = Input;

export const QuantityAdjust = ({onAdjust, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [adjustment, setAdjustment] = useState(0);
    const [mode, setMode] = useState(0);
    const [notes, setNotes] = useState(undefined);

    const adjustForSubtract = (value, mode) => {
        return ((mode === InventoryAdjustmentType.Subtract) && (value > 0)) ?
            // turn the value negative
            -value : value;
    }

    const onOpen = () => {
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onAdjust) {
            onAdjust(adjustForSubtract(adjustment, mode), mode, notes);
            setNotes(undefined);
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (val) => {
        if (val) {
            setAdjustment(val);
        } else {
            setAdjustment(0);
        }
    }

    const onModeChange = (e) => {
        setMode(e.target.value);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const radioOptions = [
        { value: InventoryAdjustmentType.Add, label: "Add Inventory" },
        { value: InventoryAdjustmentType.Subtract, label: "Remove Inventory"},
        { value: InventoryAdjustmentType.Set, label: "Set Inventory"}
    ]

    const radioStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
    }

    let quantity = ((mode === InventoryAdjustmentType.Subtract) && (adjustment < 0)) ? - adjustment : adjustment;
    const messages = [
        `${adjustment} will be added`,
        `${quantity} will be subtracted`,
        `inventory will be set to ${adjustment}`
    ];
    const message = messages[mode];

    const okDisabled = ((notes==="") || (notes===undefined));

    return <div>
            <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
            <Modal width={400} open={isOpen} onOk={onOk} onCancel={onCancel} okButtonProps={{disabled: okDisabled}}>
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col><InputNumber style={{width: 300}} precision={0} onChange={onInputChange} /></Col>
                </Row>
                <Radio.Group style={radioStyle} defaultValue={mode} options={radioOptions} onChange={onModeChange}></Radio.Group>
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col style={{color: 'red'}}>{message}</Col>
                </Row>
                <div style={{marginBottom: '25px'}}>
                    <TextArea placeholder={"Transaction Notes"} value={notes} maxLength={512} rows={4} showCount onChange={onNotesChange} />
                </div>
            </Modal>
        </div>
}